// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".error__text[data-v-6c076c8e]{font-size:12px;color:#f74949;margin-top:6px;margin-left:12px}.check__error[data-v-6c076c8e]{margin-left:32px}", ""]);
// Exports
module.exports = exports;
